import { Box } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { DateFormatTypes } from '@jfs/utils'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../components/Container'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { dateFormatter } from '../../utils'
import { ModalDialogContainer } from './ModalDialogContainer'
import { Pagination } from './Pagination'

export const AuditForMidModal = ({ show, onDismiss, clickedMerchantDetail, type }) => {
  const { auditForAMidAsync, transactions, downloadEvidenceAsync, exportAudit } = useStores((store) => ({
    auditForAMidAsync: store.riskConfig.auditForAMidAsync,
    transactions: store.riskConfig.auditForAMid,
    downloadEvidenceAsync: store.riskConfig.downloadRiskTnxsEvidenceAsync,
    exportAudit: store.riskConfig.exportAudit,
  }))

  const [lazyAuditForAMidAsync, auditForAMidHandler] = useLazyApiData(auditForAMidAsync)
  const [lazyDownloadEvidence] = useLazyApiData(downloadEvidenceAsync)
  const [lazyExportAudit, exportAuditHandler] = useLazyApiData(exportAudit)

  const abortControllerRef = useRef<AbortController>()

  const [paginationInfo, setPaginationInfo] = useState({
    dataWindow: 10,
    pageNumber: 1,
    total: 0,
  })

  const fetchAuditForAMid = useCallback(
    (pageNumber, dataWindow) => {
      lazyAuditForAMidAsync(type, clickedMerchantDetail?.entityId, pageNumber, dataWindow)
    },
    [clickedMerchantDetail?.entityId, lazyAuditForAMidAsync, type],
  )

  useEffect(() => {
    fetchAuditForAMid(1, 10)
    return () => {
      abortControllerRef?.current?.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getAbortController = () => {
    abortControllerRef.current = new AbortController()
    return abortControllerRef.current
  }

  useEffect(() => {
    if (auditForAMidHandler.state === 'fulfilled') {
      setPaginationInfo({
        dataWindow: paginationInfo.dataWindow,
        pageNumber: auditForAMidHandler?.data?.pageNo,
        total: auditForAMidHandler?.data?.totalElements,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditForAMidHandler.state])

  const { width }: any = useWindowDimensions()

  const downloadEvidence = useCallback(
    (rowData) => {
      console.log('htag clickedMerchantDetail', rowData)
      rowData.docId && lazyDownloadEvidence(rowData?.entityId, rowData.docId)
    },
    [lazyDownloadEvidence],
  )

  const onPageClick = useCallback(
    (pageNumber: number) => {
      console.log('onPageClick pageNumber =', pageNumber)
      setPaginationInfo({ ...paginationInfo, pageNumber })
      fetchAuditForAMid(pageNumber, paginationInfo.dataWindow)
    },
    [fetchAuditForAMid, paginationInfo],
  )

  const onItemCountSelect = useCallback(
    (count: string) => {
      console.log('onItemsCountSelect count =', count)
      setPaginationInfo({ ...paginationInfo, pageNumber: 1, dataWindow: parseInt(count, 10) })
      fetchAuditForAMid(1, count)
    },
    [fetchAuditForAMid, paginationInfo],
  )

  const exportAuditFile = () => {
    lazyExportAudit(clickedMerchantDetail?.entityId, type, getAbortController)
  }

  return (
    <ModalDialogContainer show={show} onDismiss={onDismiss} merchantId={clickedMerchantDetail?.entityId}>
      <Container
        flex={1}
        nativeID="vertical-scroll"
        isLoading={auditForAMidHandler.state === 'pending'}
        errorMessage={auditForAMidHandler?.data?.message as any}
        minHeight={150}
        onRetry={fetchAuditForAMid}>
        <NewTable
          data={transactions.map((item) => ({
            ...item,
            settlementNetAmount: '₹ ' + item?.settlementNetAmount,
            createdAt: dateFormatter(item?.createdAt, DateFormatTypes.DATE_AM_PM),
          }))}
          rowHeight={32}
          headerHeight={38}
          commentsData={[
            { key: 'entityId', heading: 'Entity Id' },
            //{ key: 'entityName', heading: 'Entity Name' },
            { key: 'originalTransactionId', heading: 'Transaction Id' },
            { key: 'settlementNetAmount', heading: 'Settlement NetAmount' },
            { key: 'type', heading: 'Type' },
            { key: 'createdBy', heading: type === 'PAYOUT_STAGED' ? 'Held By' : 'Released By' },
            { key: 'createdAt', heading: type === 'PAYOUT_STAGED' ? 'Held At' : 'Released At' },
            { key: 'comments', heading: 'Comments' },
          ]}
          tableWidth={width * 0.9 - 20}
          headerRowKeys={transactionsHeaders(type)}
          customWidthFunc={getCustomColumnWidth}
          onRowClick={downloadEvidence}
          onAction={(index: any, id: any, data) => downloadEvidence(data)}
        />
      </Container>
      <Pagination
        dataWindow={paginationInfo.dataWindow}
        onPageClick={onPageClick}
        onItemsCountSelect={onItemCountSelect}
        pageNumber={paginationInfo.pageNumber}
        totalPages={Math.ceil(paginationInfo.total / paginationInfo.dataWindow)}
        total={paginationInfo.total}
      />

      <Box pv={16} justifyContent={'center'} alignItems={'center'}>
        <ButtonNew
          onPress={exportAuditFile}
          type={'primaryIconSmall'}
          title={'Export'}
          icon="DOWNLOAD"
          width={300}
          isLoading={exportAuditHandler.state === 'pending'}
        />
      </Box>
    </ModalDialogContainer>
  )
}

export const transactionsHeaders = (type: string) => ({
  originalTransactionId: 'Transaction Id',
  settlementNetAmount: 'Total Amount',
  createdAt: type === 'PAYOUT_STAGED' ? 'Held At' : 'Released At',
  createdBy: type === 'PAYOUT_STAGED' ? 'Held By' : 'Released By',
  comments: 'Comments',
  actionDownload: ' ',
})

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    originalTransactionId: 120,
    settlementNetAmount: 30,
    createdAt: 80,
    createdBy: 50,
    comments: 100,
    actionDownload: 50,
  }
  return columnsKeyWidth[columnKey] ?? 150
}
